export default __webpack_public_path__ + "images/SpeakersPhotos/Carolina Miyata.jpg?3672f408";